import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { formatCurrency, formatK } from './format';

export const SalesTrendChart = ({ monthlySales, monthlyDeliveries }) => {
    const data = monthlySales.map((m, i) => ({
        label: m.label,
        venduto: m.value || 0,
        vendutoN: m.count || 0,
        consegnato: monthlyDeliveries[i]?.value || 0,
        consegnatoN: monthlyDeliveries[i]?.count || 0,
    }));
    return (
        <Card className="lg:col-span-2" data-testid="sales-trend-chart">
            <CardHeader>
                <CardTitle className="font-heading uppercase text-lg flex items-center gap-2">
                    <TrendingUp size={18} /> Venduto e consegnato — ultimi 12 mesi
                </CardTitle>
                <p className="text-sm text-muted-foreground">Importo delle offerte confermate e dei veicoli consegnati in ogni mese. Passa sopra una barra per vedere il numero di veicoli.</p>
            </CardHeader>
            <CardContent>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="label" fontSize={12} />
                        <YAxis tickFormatter={formatK} fontSize={12} />
                        <Tooltip formatter={(v, n, p) => [`${formatCurrency(v)} · ${n === 'Venduto' ? p.payload.vendutoN : p.payload.consegnatoN} veicoli`, n]} />
                        <Legend content={() => (
                            <div className="flex justify-center gap-5 text-sm pt-2">
                                <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm" style={{ background: '#D32F2F' }} />Venduto</span>
                                <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm" style={{ background: '#F57C00' }} />Consegnato</span>
                            </div>
                        )} />
                        <Bar dataKey="venduto" name="Venduto" fill="#D32F2F" radius={[4, 4, 0, 0]} />
                        <Bar dataKey="consegnato" name="Consegnato" fill="#F57C00" radius={[4, 4, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};
